export const API_NAME = {
  APPLICANTS: 'Applicants',
  APPLICATIONS: 'Applications',
  ASSETS: 'Assets',
  BROKER_INTERVIEWS: 'Broker Interviews - Borrower',
  BROKER_INTERVIEWS_GUARANTOR: 'Broker Interviews - Guarantor',
  COMPANIES: 'Related Companies',
  CREDIT_REPORTS: 'Credit Report',
  CUSTOMERS: 'Customers',
  EMPLOYMENTS: 'Employment',
  EXPENSES: 'Expenses',
  FINANCIAL_SITUATIONS: 'Financial Situation',
  INCOMES: 'Income',
  INVITATIONS: 'Invitations',
  LEADS: 'Leads',
  LIABILITIES: 'Liabilities',
  POST_PRODUCT_SELECT: 'Post Product Select',
  PRODUCT_SELECTION: 'Product Selection',
  PRODUCT_PREFERENCES: 'Product Preferences',
  RELATED_PARTIES: 'Related Parties',
  REQUIRED_DOCUMENTS: 'Required Documents',
  REQUIRED_ACTION_CONDITION: 'Required Action Condition',
};
